export default "__VITE_ASSET__1bff0797__"